module.exports = __webpack_public_path__ + "static/media/send.b0a2cdf6.svg";